

import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const servicetListEndpoint = ApiEndpoints.serviceForm.serviceList;

const tableHeader = ["Date","Name", "lastname" , "phone", "email",  "industries",  "solutions",  "message", "source URL"];
const tbody = ["createdAt","first_name", "last_name" , "phoneNumber", "email",  "industries", "solutions", "message", "source_url"];

export default function ServicesForm() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", servicetListEndpoint);
            const result = response.vas_form_data;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const pagename = {
      name: 'Service Form ',
      user: 'Admin',
      innerpage: 'Service Form'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
